import authReducer from "./authReducer";
import configReducer from "./configReducer";

let reducerCombined = {
  auth: authReducer,
  config: configReducer,
};

export default reducerCombined;
